import React from 'react'
import Header from '../components/Header/Header'
import Navbar from '../components/Navbar/Navbar'

const Student_Travel_Bursaries = () => {
    return (
        <div>
            <Header/>
            <Navbar/>
            <div className="px-4">
        <div className="max-w-7xl mx-auto bg-white p-6 ">
          {/* Header Section */}
          <header className="flex justify-between items-center mb-2 pb-6">
            <h1 className="text-3xl md:text-4xl text-blue-800 ">I.I.S. Awards</h1>

          </header>

          {/* Content Section */}
          <section>
            <h2 className="text-2xl md:text-3xl text-gray-600 mb-4 ">Student Travel Bursaries</h2>
            <h3 className="text-1xl md:text-2xl text-indigo-600 mb-4 ">Eligibility and guidelines for travel grant to attend 51st Annual meeting of the Indian Immunology Society meeting.</h3>
            <p className="text-md md:text-lg text-gray-600 mb-4">
              1. The applicant should be a member of the Indian Immunology Society from last two years (as of the 19th November 2025).</p>

            <p className="text-md md:text-lg text-gray-600 mb-4">
            2.	The applicant should be below 35 years of age.
            </p>
            <p className="text-md md:text-lg text-gray-600 mb-4">
            3.	The applicant should be a registered Ph.D candidate/ Project fellow/ Research assistant/ Project assistant etc. (Instructors/ Assistant Professor/ Faculty/ Scientist/ Research Scientist/ Project Scientist etc. are not eligible).
            </p>
            <p className="text-md md:text-lg text-gray-600 mb-4">
            4.	A recommendation letter from the mentor/Reporting authority that the applicant has no other sources of funding to attend the meeting.
            </p>
            <p className="text-md md:text-lg text-gray-600 mb-4">
            5.	The applicant must have an abstract submitted to the meeting.
            </p>
            <p className="text-md md:text-lg text-gray-600 mb-4">
            6.	The travel grant winner will be eligible for reimbursement of registration fee and III AC return fare from official place of work to Bengaluru.
            </p>
            <p className="text-md md:text-lg text-gray-600 mb-4">
            7.	The applicants are eligible to get a maximum of Rs 10000 (ten thousand only) towards travel and Registration.
            </p>
            <p className="text-md md:text-lg text-gray-600 mb-4">
            8.	If the number of eligible candidates are less than the budgeted number of grants (travel + registration), the IIS will give “registration alone” reimbursement to local candidates.
            </p>

            <h4 className="text-1xl md:text-2xl text-indigo-600 mb-4 ">Documents to be sent with travel grant application</h4>
       
            <p className="text-md md:text-lg text-gray-600 mb-4">
            1.	Cover letter with complete address of place of work and name of the railway station travelling from to Bengaluru. (If the candidate decides to travel by air, he /she will be reimbursed the III AC return fare as calculated from Nearest Railway station of place of work to Prayagraj along with the registration fee).
            </p>
            <p className="text-md md:text-lg text-gray-600 mb-4">
            2.	Proof of registration.
            </p>
            <p className="text-md md:text-lg text-gray-600 mb-4">
            3.	Proof of abstract submission (Attach copy of abstract as well).
            </p>
            <p className="text-md md:text-lg text-gray-600 mb-4">
            4.	Brief CV.
            </p>
            <p className="text-md md:text-lg text-gray-600 mb-4">
            5.	Proof of age.
            </p>
            
          </section>
        </div>
        <div className="bg-gray-100 mt-6 py-4">
          <div className="max-w-7xl mx-auto px-4 text-center">
            
            <p className="text-base mb-6">
              Nomination Form:
              <a
                href="/nomination_form.pdf"
                download
                className="text-[#4f46e5] underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                click here
              </a>
              .
            </p>
            <p className="text-base mb-6">
              Guideline:
              <a
                href="/guidelines.pdf"
                download
                className="text-[#4f46e5] underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                click here
              </a>
              .
            </p>

          </div>
        </div>
      </div>
        </div>
    )
}

export default Student_Travel_Bursaries
